/*
 * ---------------------------------------------------------------------
 * Userlike Action Types
 * ---------------------------------------------------------------------
 */
export const SET_USERLIKEWIDGETS = "SET_USERLIKEWIDGETS";
